module.exports = __webpack_public_path__ + "img/headphones-700.62ebbb41.jpg";